import React from "react";
import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { useLang } from "../lib/i18n";
import { HELP } from "../lib/helpContent";

// Small "?" contextual help. `k` = a key in HELP[lang].hints.
export function HelpHint({ k, side = "top" }) {
  const { lang } = useLang();
  const h = (HELP[lang] || HELP.fr).hints[k];
  if (!h) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={`help-hint-${k}`} aria-label={h.title}
          className="inline-flex items-center justify-center w-11 h-11 -m-3 sm:w-5 sm:h-5 sm:m-0 rounded-full text-[hsl(var(--muted-foreground))] hover:text-neon transition-colors align-middle">
          <HelpCircle size={15} />
        </button>
      </PopoverTrigger>
      <PopoverContent side={side} className="glass border-white/10 w-72 text-left z-50" data-testid={`help-hint-content-${k}`}>
        <p className="text-sm font-semibold mb-1">{h.title}</p>
        <p className="text-xs text-[hsl(var(--muted-foreground))] leading-relaxed">{h.text}</p>
      </PopoverContent>
    </Popover>
  );
}
